import Cookies from 'js-cookie'
export const Local = {
	allowStorage:window.localStorage ? true : false,
	setKey(key) {
		return `naweb:${key}`;
	},
	set(key, val) {
		try {
			if (Local.allowStorage) {
				window.localStorage.setItem(Local.setKey(key), JSON.stringify(val));
			} else {
				Cookies.set(Local.setKey(key), val ? JSON.stringify(val) : "");
			}
		} catch {
			alert("Please open the LocalStorage function of the browser, thank you!");
		}
	},
	get(key) {
		if (Local.allowStorage) {
			let json = window.localStorage.getItem(Local.setKey(key));
			return JSON.parse(json);
		} else {
			
			let json = Cookies.get(Local.setKey(key));
			
			return json?JSON.parse(json):"";
		}
	},
	remove(key) {
		if (Local.allowStorage) {
			window.localStorage.removeItem(Local.setKey(key));
		} else {
			Cookies.remove(Local.setKey(key));
		}
	},
	clear() {
		if (Local.allowStorage) {
			window.localStorage.clear();
		} else {
			Cookies.clear();
		}
	},
};
export const Session = {
	allowsessionStorage: window.sessionStorage ? true : false,
	set(key, val) {
		if (Session.allowsessionStorage) {
			if (key === 'token') return window.sessionStorage.setItem(Local.setKey(key), val);
			window.sessionStorage.setItem(Local.setKey(key), JSON.stringify(val));
		}
		else {
			Local.set(key,val);
		} 
	},
	get(key) {
		if (Session.allowsessionStorage) {
			if (key === 'token') return window.sessionStorage.getItem(Local.setKey(key));
			let json = window.sessionStorage.getItem(Local.setKey(key));
			return JSON.parse(json);
		} else {
			return Local.get(key);
		
		}
	},

	remove(key) {
		if (Session.allowsessionStorage) {
			window.sessionStorage.removeItem(Local.setKey(key));
		} else {
			Local.remove(key);
		}
	},
	clear() {
		if (Session.allowsessionStorage) {
			window.sessionStorage.clear();
		} else {
			Local.clear();
		}
	},
};
export const accessTokenKey = 'access-token';
export const refreshAccessTokenKey = `x-${accessTokenKey}`;

export const getToken = () => {
	return Local.get(accessTokenKey) ? Local.get(accessTokenKey) : Session.get('token');
};
export const setToken = (accesstk, refreshtk) => {
	Local.set(accessTokenKey, accesstk);
	Local.set(refreshAccessTokenKey, refreshtk);
	Session.set('token', accesstk);

};
export const getRefreshToken = () => {
	return Local.get(refreshAccessTokenKey);
};
export const getTenantId = () => {
	return Session.get("deviceid") || "";
};
export const clearAccessTokens = () => {
	clearTokens();
	//window.location.reload();
}

export const clearTokens = () => {
	Local.remove(accessTokenKey);
	Local.remove(refreshAccessTokenKey);
	Session.clear();
};


export function decryptJWT(token) {
	token = token.replace(/_/g, '/').replace(/-/g, '+');
	var json = decodeURIComponent(escape(window.atob(token.split('.')[1])));
	return JSON.parse(json);
}


export function getJWTDate(timestamp) {
	return new Date(timestamp * 1000);
}

export function tansParams(params) {
	let result = '';
	for (const propName of Object.keys(params)) {
		const value = params[propName];
		var part = encodeURIComponent(propName) + '=';
		if (value !== null && value !== '' && typeof value !== 'undefined') {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
						let params = propName + '[' + key + ']';
						var subPart = encodeURIComponent(params) + '=';
						result += subPart + encodeURIComponent(value[key]) + '&';
					}
				}
			} else {
				result += part + encodeURIComponent(value) + '&';
			}
		}
	}
	return result;
}